<section class="flex flex-col gap-2">
    <div class="flex flex-col w-full gap-2">
        @if (label()) {
            <app-label class="text-black" [required]="required()">{{ label() }}</app-label>
        }

        <div class="flex items-center w-full gap-2">
            <div class="relative w-full">
                <app-input
                    #inputRef
                    [(value)]="value"
                    [disabled]="verified()"
                    [maxlength]="12"
                    placeholder="사업자 등록번호를 입력해주세요."
                />
            </div>
            @if (verified()) {
                <app-button (click)="handleReset()" color="primary" class="shrink-0" variant="outline"> 변경 </app-button>
            } @else {
                <app-button (click)="handleValid()" color="primary" class="shrink-0" variant="outline"> 중복확인 </app-button>
            }
        </div>

        @if (!verified() && clickValid() && validBusinessNoPatten()) {
            <div class="flex items-center gap-1">
                <div class="flex items-center">
                    <app-icon size="xs" class="text-red-500" name="ic:sharp-close"></app-icon>
                </div>
                <p class="text-sm font-medium text-red-500">이미 가입된 기업</p>
            </div>
        } @else if (verified() && value() && clickValid() && validBusinessNoPatten()) {
            <div class="flex items-center gap-1">
                <div class="flex items-center">
                    <app-icon size="xs" class="text-emerald-500" name="ic:outline-circle"></app-icon>
                </div>
                <p class="text-sm font-medium text-emerald-500">사용 가능</p>
            </div>
        } @else if (!validBusinessNoPatten() && clickValid()) {
            <div class="flex items-center gap-1">
                <div class="flex items-center">
                    <app-icon size="xs" class="text-red-500" name="ic:sharp-close"></app-icon>
                </div>
                <p class="text-sm font-medium text-red-500">사업자 등록번호 형식을 확인해주세요.</p>
            </div>
        }
    </div>
</section>
